import {ErrorBoundary} from "react-error-boundary";
import {DiscountCodesPage} from "../../../discounts/useCases/get-discounts/page";
import {Alert, Button} from "antd";
import {DashboardWrapper} from "../../../layouts/dashboard-wrapper";

export function DiscountsPage() {
  return (
    <DashboardWrapper pageTitle="Discounts">
      <ErrorBoundary
        FallbackComponent={({error, resetErrorBoundary}) => (
          <div>
            <Alert
              message="Sorry, something went wrong."
              showIcon
              description={error.message}
              type="error"
              action={
                <Button
                  onClick={() => {
                    resetErrorBoundary();
                  }}
                  size="small"
                  danger
                >
                  Reset
                </Button>
              }
            />
          </div>
        )}
      >
        <DiscountCodesPage />
      </ErrorBoundary>
    </DashboardWrapper>
  );
}
